import {useState, useEffect} from 'react'
import { Link, useLocation, useHistory } from 'react-router-dom'
import Select from 'react-select';

const Header = ({language, languages, onLanguageChange, breadcrumbObject, editorProfile}) => {
	const [showDevMenu, setShowDevMenu] = useState(false)
	const [profile, setProfile] = useState()
	let history = useHistory();
	let showLink = false
	let showBack = false

	useEffect(() => {
		setProfile(editorProfile)
	  },[editorProfile])

	if(breadcrumbObject.link !== '' && breadcrumbObject.linkText !== ''){
		showLink = true
	}
	if(breadcrumbObject.name !== ''){
		showBack = true
	}
    const handleBackClick = () =>{
        global.config.History.pop()
        history.goBack()
    }
	
    const handleShowDevMenu = (hide) =>{
		setShowDevMenu(showDevMenu ? false : true)
    }
	const handleClickOutside = (visible) =>{
		setTimeout(() => {
			setShowDevMenu(visible)
		},100)
    }
	const hideDevMenu = (hide) =>{
		setShowDevMenu(showDevMenu ? false : false)
    }

    const location = useLocation()
    const handleChange = (selectedOption) => {
        onLanguageChange( selectedOption )
        console.log(`Option selected:`, selectedOption);
    }

    return (
		<>
		{(profile) && <>
        <div id="cc_topmenu">		
			<div className="site-select">
				<span className="cc_header">
					<Link to="/"><i className="sprite-icon sprite-icon-white sprite-icon-x400 icon-contentcloud"></i></Link>
				</span>				
			</div>
			<div className="main-select">
				<ul className="main-menu">
					<li className="d-level1">
						<Link onClick={hideDevMenu} to="/content" className={`robotoCondenced ${ location.pathname.startsWith('/content') && 'active-main' }`}>
							<span className="icon">
								<i className="sprite-icon sprite-icon-white icon-gallery sprite-icon-x150"></i>
							</span>
							<span>
								{language.value === 'DA' ? 'Indhold' : 'Content'}
							</span>
						</Link>
					</li>
					{(profile.hasAccessToSettings || profile.hasAccessToModels || profile.hasAccessToProfiles) &&
					<li className="d-level1" tabIndex="0" onClick={handleShowDevMenu} onBlur={e => handleClickOutside(false)}>
						<span className={`robotoCondenced ${ location.pathname.startsWith('/control/') && 'active-main' }`}>
							<span className="icon">
								<i className="sprite-icon sprite-icon-white icon-filter sprite-icon-x150"></i>
							</span>
							<span>
								{language.value === 'DA' ? 'Kontrolpanel' : 'Control Panel'}
							</span>
						</span>
						<ul id="developer_menu" className={!showDevMenu && 'hidden'}>
							{(profile.hasAccessToModels) &&
							<li className="developer_menu_item">
								<Link onClick={handleShowDevMenu} to={`/control/contentModels`}>
									<span className="icon">
										<i className="sprite-icon sprite-icon-white icon-gallery"></i>
									</span>
									<span>{language.value === 'DA' ? 'Indholdsmodeller' : 'Content Models'}</span>
								</Link>
							</li>
							}
							{(profile.hasAccessToProfiles) &&
							<li className="developer_menu_item">
								<Link onClick={handleShowDevMenu} to={`/control/profiles`}>
									<span className="icon">
										<i className="sprite-icon sprite-icon-white icon-user"></i>
									</span>
									<span>{language.value === 'DA' ? 'Profiler/Brugere' : 'Profiles/Users'}</span>
								</Link>
							</li>		
							}
							{(profile.hasAccessToSettings) &&					
							<li className="developer_menu_item">
								<Link onClick={handleShowDevMenu} to={`/control/settings`}>
									<span className="icon">
										<i className="sprite-icon sprite-icon-white icon-filter"></i>
									</span>
									<span>{language.value === 'DA' ? 'Indstillinger' : 'Settings'}</span>
								</Link>
							</li>
							}
						</ul>					
					</li>
					}
				</ul>
			</div>
			<div className="action-btn">
                <Select 
					className="languageSelect"
					classNamePrefix="languageSelect"
					options={languages} 
					onChange={handleChange} 
					value={language}
					/>
			</div>

		</div>
		<div id="cc_breadcrumb">
			<span className="backlink">
				{showBack && <span onClick={handleBackClick}><i className="sprite-icon icon-arrow-previous"></i></span>}
			</span>
			<span className="pagelink">
				<span>{breadcrumbObject.type}<b>{breadcrumbObject.name}</b></span>
				{showLink && <span>{language.value === "DA" ? "Indholdsmodel: " : "Contentmodel: "} <Link to={breadcrumbObject.link}>{breadcrumbObject.linkText}</Link></span> }
			</span>
		</div>
		</>
		}
		</>
    )
}

export default Header
